<script lang="ts">
  export let tooltip: string
</script>

<div data-tooltip={tooltip}>
  <slot />
</div>

<style lang="scss">
  [data-tooltip] {
    position: relative;
    font-weight: normal;
    z-index: 999999;
  }

  [data-tooltip]:before,
  [data-tooltip]:after {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: .2s ease-out;
    transform: translate(-50%, 5px)
  }

  [data-tooltip]:before {
    position: absolute;
    white-space: break-spaces;
    margin-top: 20px;
    margin-left: 30px;
    padding: 12px;
    background-color: #FFFFFF;
    color: #30333D;
    content: attr(data-tooltip);
    text-align: center;
    border-radius: 10px;
    font-size: 14px;
    width: 150px;
    line-height: 20px;
    box-shadow: 0px 1px 12px rgba(48, 51, 61, 0.18);
  }

  [data-tooltip]:hover:before,
  [data-tooltip]:hover:after {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, 0)
  }

  @media (max-width: 500px){
    [data-tooltip]:before {
      transform: none !important;
      right: -20px;
      height: auto;
      white-space: break-spaces;
    } 
  }
</style>